import axios from "axios";
import message from "components/CustomMessage";
import React, { useEffect, useState } from "react";
import AnyaModal from "views/Dashboards/AnyaModal";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import { useGlobalSettingsContext } from "contexts/GlobalSettingsContext";
import { LoadingIcon } from "components/Icons";
import { MarkdownFormatter } from "components/MarkupFormatter";
import { ANYA_PROMPTS } from "views/Dashboards/anyaConstants";
import { useFindingDetails } from "./FindingDetailsProvider";

const RemediationAction = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const featureFlags = useFeatureFlag();
  const { anyaAIAssistantEnabled: isAnyaGloballyEnabled } = useGlobalSettingsContext();
  const { id, existingConversations } = useFindingDetails();
  
  useEffect(() => {
  // Load legacy remediation when FF is off OR when FF is on but Anya is globally disabled
  if (featureFlags.AI_ANYA_REMEDIATION_ACTIONS_DISABLED || (!featureFlags.AI_ANYA_REMEDIATION_ACTIONS || (featureFlags.AI_ANYA_REMEDIATION_ACTIONS && !isAnyaGloballyEnabled))) {
    setData(null);
    setLoading(true);
    // Create a controller so we can cancel if `id` changes mid-request
    /* global AbortController */
    const controller = new AbortController();
    axios({
      url: `/api/findings/${id}/remediation-steps`,
      headers: {
        accept: "*",
        "content-type": "application/json",
      },
      method: "GET",
      onDownloadProgress: (progressEvent) => {
        const xhr = progressEvent.currentTarget;
        const { responseText } = xhr;
        setData(parseResponseData(responseText));
      },
      signal: controller.signal
    })
      .then(({ response }) => Promise.resolve(response))
      .catch((e) => {
        if (e.response && e.response.status === 429) {
          message.error("Rate Limit Exceeded. Please try again after sometime. If the issue persists, please contact support.");
        } else {
          console.log(e);
        }
      })
      .finally(() => setLoading(false));
      // Aborting old request when `id` changes or component unmounts
      return () => {
        controller.abort()
      }
}
  }, [featureFlags.AI_ANYA_REMEDIATION_ACTIONS, isAnyaGloballyEnabled, id, featureFlags.AI_ANYA_REMEDIATION_ACTIONS_DISABLED]);

  return (
    <div className="m-t-xs overflow-auto remediation-anya-container" style={{ minHeight: "350px", height: "100%" }}>
      {!featureFlags.AI_ANYA_REMEDIATION_ACTIONS_DISABLED && (featureFlags.AI_ANYA_REMEDIATION_ACTIONS && isAnyaGloballyEnabled) ? (
          <AnyaModal
            props={{
              defaultPromptPrefix: ANYA_PROMPTS.FINDING_REMEDIATION,
              dashboardId: id,
              config: {
                widgetType: id,
                existingConversations
              },
              showHistory: false,
              isNewChat: false,
              showTitle: false,
              autoFocus: true,
              initialMessageSent: true,
            }}
            showBorder={false}
          />
      ) : (
      <div>
          { data && <MarkdownFormatter markdown={data} /> }
          { loading && <LoadingIcon /> }
      </div>
      )}
    </div>
  );
};

  const parseResponseData = (data) => {
    return data
      ?.replaceAll("data:", "")
      .split("\n")
      .filter((s) => s.length > 0)
      .map((s) => {
        try {
          return JSON.parse(s);
        } catch (e) {
          console.log(e);
          return null;
        }
      })
      .filter((v) => v !== null)
      .map((v) => v.value)
      .join("");
  };

export default RemediationAction;